
(function () {
  'use strict';

  var KEY = '3idee_auswahl';

  var HOLZ_STABIL_AB_CM = 3;

  function zuDatenbank(gruppe, dickeCm) {
    if (gruppe === 'glas') return 'glass';
    if (gruppe === 'leicht') return 'honeycomb';
    if (gruppe === 'beschichtet') return 'mdf';
    if (gruppe === 'holz') {
      return (dickeCm && dickeCm >= HOLZ_STABIL_AB_CM) ? 'solid_wood_thick' : 'solid_wood_thin';
    }
    return '';
  }

  function zuGruppe(art) {
    if (art === 'glass') return 'glas';
    if (art === 'honeycomb' || art === 'chipboard') return 'leicht';
    if (art === 'mdf' || art === 'veneered') return 'beschichtet';
    if (art === 'solid_wood_thin' || art === 'solid_wood_thick' || art === 'soft_wood') return 'holz';
    return '';
  }

  function lesen() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null') || null; } catch (e) { return null; }
  }

  function schreiben(tisch) {
    try {
      var alt = lesen() || {};
      alt.tisch = tisch;
      alt.zeit = Date.now();
      localStorage.setItem(KEY, JSON.stringify(alt));
      document.dispatchEvent(new CustomEvent('finder:auswahl'));
    } catch (e) {}
  }

  function fuellen(el) {
    var t = (lesen() || {}).tisch || null;
    var sel = el.querySelector('[data-tsa-art]');
    var num = el.querySelector('[data-tsa-dicke]');
    if (sel) sel.value = t ? (t.gruppe || zuGruppe(t.art)) : '';
    if (num) num.value = (t && t.dicke_cm) ? String(t.dicke_cm) : '';
    wegZeigen(el);
  }

  function wegZeigen(el) {
    var weg = el.querySelector('[data-tsa-weg]');
    var sel = el.querySelector('[data-tsa-art]');
    var num = el.querySelector('[data-tsa-dicke]');
    if (weg) weg.hidden = !((sel && sel.value) || (num && num.value));
  }

  function zeichnen(frisch) {
    document.querySelectorAll('[data-tsa]').forEach(function (el) {
      if (!frisch && el.hasAttribute('data-tsa-fertig')) return;
      el.setAttribute('data-tsa-fertig', '');
      fuellen(el);
    });
  }

  function uebernehmen(el) {
    var sel = el.querySelector('[data-tsa-art]');
    var num = el.querySelector('[data-tsa-dicke]');
    var gruppe = sel ? sel.value : '';
    var dicke = num ? parseFloat(num.value) : NaN;
    if (!dicke || !isFinite(dicke) || dicke <= 0) dicke = null;

    var art = (gruppe && gruppe !== 'unbekannt') ? zuDatenbank(gruppe, dicke) : '';

    wegZeigen(el);
    var wert = (art || dicke)
      ? { art: art, gruppe: gruppe, dicke_cm: dicke, quelle: 'seite' }
      : null;
    if (el.closest('[data-fenster="setup"]')) {
      document.dispatchEvent(new CustomEvent('stf:tisch', { detail: wert }));
      return;
    }
    schreiben(wert);
  }

  if (!window.__tischangabeBereit) {
    window.__tischangabeBereit = true;

    document.addEventListener('change', function (e) {
      var el = e.target.closest && e.target.closest('[data-tsa]');
      if (!el) return;
      if (!e.target.matches('[data-tsa-art], [data-tsa-dicke]')) return;
      uebernehmen(el);
    });

    var timer = null;
    document.addEventListener('click', function (e) {
      var weg = e.target.closest && e.target.closest('[data-tsa-weg]');
      if (!weg) return;
      var el = weg.closest('[data-tsa]');
      if (!el) return;
      var sel = el.querySelector('[data-tsa-art]');
      var num = el.querySelector('[data-tsa-dicke]');
      if (sel) sel.value = '';
      if (num) num.value = '';
      uebernehmen(el);
      if (sel) sel.focus();
    });

    document.addEventListener('input', function (e) {
      if (!e.target.matches || !e.target.matches('[data-tsa-dicke]')) return;
      var el = e.target.closest('[data-tsa]');
      if (!el) return;
      wegZeigen(el);
      clearTimeout(timer);
      timer = setTimeout(function () { uebernehmen(el); }, 600);
    });

    document.addEventListener('finder:auswahl', function () { zeichnen(true); });
  }

  if (!window.__tischangabeBeobachter && window.MutationObserver) {
    var anstoss = null;
    window.__tischangabeBeobachter = new MutationObserver(function () {
      clearTimeout(anstoss);
      anstoss = setTimeout(function () { zeichnen(false); }, 60);
    });
    window.__tischangabeBeobachter.observe(document.documentElement,
                                           { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', zeichnen);
  else zeichnen();
})();
